import { Toaster } from "react-hot-toast"
import Layout from "../shared/Layout"
import { useEffect, useRef, useState } from "react";
import toast from "react-hot-toast";
import { DeleteInstaFeedById, DeleteSocialVideoById, GetInstaFeed, GetSocialVideo, SaveInstaFeed, SaveSocialVideo } from "../../_services";
import DataTable from "react-data-table-component";
import { API_URL, baseurl, imageurl } from "../../_config";
import axios from "axios";

const InstaFeed = () => {
    const [isFormopen, setIsFormopen] = useState(false);
    const [loading, setLoading] = useState(false);
    const [instaFeedData, setInstaFeedData] = useState([]);
    const [instaFeedId, setInstaFeedId] = useState(null);
    const fileInputRef = useRef(null);
    const [formData, setFormData] = useState({
        instafeedId: 0,
        videoUrl: "",
        instaUrl: 'insta',
        file: "",
        createdBy: 0,
        isActive: false
    });

    const onOpen = () => {
        setInstaFeedId(null)
        handleReset();
        setIsFormopen(true)
    }

    const handleReset = () => {
        setFormData({
            instafeedId: 0,
            videoUrl: "",
            instaUrl: 'insta',
            file: "",
            createdBy: 0,
            isActive: false
        })
        if (fileInputRef.current) {
            fileInputRef.current.value = '';
        }
    }

    const handleChange = async (e) => {
        const { name, value, type, checked, files } = e.target;

        if (type === 'file' && files[0]) {
            const file = files[0];

            setFormData((prevState) => ({
                ...prevState,
                [name]: file
            }));
        } else {
            setFormData((prevState) => ({
                ...prevState,
                [name]: type === 'checkbox' ? checked : value
            }));
        }
    };

    const onSave = async (e) => {
        e.preventDefault();
        try {
            const data = await SaveInstaFeed(formData);
            if (data.isSuccess === 200) {
                toast.success("Save Successfully");
                setIsFormopen(false);
                getSocialVideos();
                handleReset();
            }

        } catch (error) {
            toast.error("Please try again later.");
        }
    };

    const onEdit = (item) => {
        setInstaFeedId(item?.instafeedId)
        setIsFormopen(true);
        setFormData({
            ...formData,
            instafeedId: item?.instafeedId,
            videoUrl: item?.videoUrl,
            instaUrl: item?.instaUrl,
            file: null,
            imagePath: item?.imagePath,
            isActive: item?.isActive
        })
    }

    const onDelete = async (id) => {
        const isConfirmed = window.confirm("Are you sure you want to delete this item?");

        if (!isConfirmed) {
            return;
        }
        const data = await DeleteInstaFeedById(id);
        if (data.isSuccess === 1) {
            getSocialVideos();
            toast.success("Delete Successfully");
        }
    };

    const isActiveToggle = async (id) => {
        try {
            const response = await axios.get(`${baseurl}${API_URL?.ActiveInstaFeedById}`, {
                params: {
                    pInstaFeedId: id
                }
            });
            if (response.status === 200 && response.data.isSuccess === 200) {
                toast.success("Update Successfully");
                getSocialVideos();
            }
        } catch (error) {
            console.log("Please try again later.");
        }
    }

    const getSocialVideos = async () => {
        try {
            const data = await GetInstaFeed();
            setInstaFeedData((prevData) => {
                if (JSON.stringify(prevData) !== JSON.stringify(data)) {
                    const sortedData = data?.sort((a, b) => {
                        return new Date(b.createdDate) - new Date(a.createdDate);
                    });

                    return sortedData;
                }
                return prevData;
            })
        } catch (error) {
            console.error(error.message);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        getSocialVideos();
    }, []);

    const columns = [
        {
            name: 'SR.No',
            selector: (row, index) => index + 1,
            sortable: false,
            width: '80px',
        },
        {
            name: 'Video',
            selector: row => row.videoUrl ? (
                <div className="video_column">
                    <video width="100" autoPlay muted>
                        <source src={`${imageurl}${row?.videoUrl}`} type="video/mp4" />
                        Your browser does not support the video tag.
                    </video>
                </div>
            ) : 'No Video',
            sortable: false,
        },
        // {
        //     name: 'URL',
        //     selector: (row) => (
        //         <div >
        //             <p>{row?.instaUrl}</p>
        //         </div>
        //     ),
        //     sortable: true,
        // },
        {
            name: 'isActive',
            selector: row => (
                <button
                    onClick={() => isActiveToggle(row.instafeedId)}
                    className={`${row.isActive ? 'active-toggle' : 'dactive-toggle'}`}
                >
                    {row.isActive ? "Active" : "Deactive"}
                </button>
            ),
            sortable: false,
        },
        {
            name: 'Action',
            cell: row => (
                <div className="d-flex" style={{ gap: "10px" }}>
                    <span title='Edit' onClick={() => onEdit(row)} className='edit_icon_wepper'>
                        <svg id="Layer_1" viewBox="0 0 512 512" width="18" height="18" xmlns="http://www.w3.org/2000/svg">
                            <g transform="matrix(1,0,0,1,0,0)">
                                <path d="m41.3 512c-22.8 0-41.3-18.5-41.3-41.3 0-2.6.2-5.2.7-7.7l27.3-144.8c1.5-8.2 5.5-15.7 11.4-21.5l274-274c14.7-14.7 35.1-22.7 57.7-22.7 8.1 0 16.1 1 24 2.8 25.5 5.9 51.1 20.7 72.2 41.8s36 46.7 41.8 72.2c7.4 31.9.2 61.7-19.8 81.7l-274 274c-5.9 5.9-13.4 9.8-21.5 11.4l-144.8 27.4c-2.5.5-5.1.7-7.7.7zm51.8-93.1 72.9-13.8 182-182-59.1-59.1-182 182zm313.3-254.2 23.1-23.1c.2-5.4-3.8-21.8-20.6-38.5-10.1-10.2-22-17.4-32.4-19.8-1.8-.4-3.7-.7-5.5-.7h-.7l-23 23z" fill="#526484" />
                                <path d="m499.4 119.1c-5.4-23.7-19.4-47.6-39.1-67.4s-43.8-33.7-67.4-39.1c-28.5-6.6-54.9-.4-72.3 17.1l-274 274c-4.5 4.4-7.5 10.1-8.7 16.3l-27.4 144.9c-3.2 17 8 33.4 24.9 36.6 1.9.4 3.9.5 5.8.5s3.9-.2 5.8-.5l145-27.4c6.2-1.2 11.9-4.2 16.3-8.6l274-274c17.5-17.5 23.7-43.9 17.1-72.4zm-328.5 295.3-90.3 17 17-90.3 191.3-191.3 73.3 73.3zm267.2-267.2-31.7 31.7-73.2-73.3 31.7-31.7c1-1 5.6-2.3 14-.4 12.2 2.8 25.8 11 37.2 22.4 23.5 23.7 25.6 47.7 22 51.3z" fill="url(#gradient1)" />
                                <defs>
                                    <linearGradient id="gradient1" x1="0%" y1="0%" x2="100%" y2="100%">
                                        <stop offset="0%" stopColor="#526484" />
                                        <stop offset="100%" stopColor="#0063ff" />
                                    </linearGradient>
                                </defs>
                            </g>
                        </svg>
                    </span>
                    <span title='Delete' onClick={() => onDelete(row.instafeedId)} className="delete_icon_weepr">
                        <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="20" height="20" viewBox="0 0 24 24">
                            <path d="M 10 2 L 9 3 L 4 3 L 4 5 L 5 5 L 5 20 C 5 20.522222 5.1913289 21.05461 5.5683594 21.431641 C 5.9453899 21.808671 6.4777778 22 7 22 L 17 22 C 17.522222 22 18.05461 21.808671 18.431641 21.431641 C 18.808671 21.05461 19 20.522222 19 20 L 19 5 L 20 5 L 20 3 L 15 3 L 14 2 L 10 2 z M 7 5 L 17 5 L 17 20 L 7 20 L 7 5 z M 9 7 L 9 18 L 11 18 L 11 7 L 9 7 z M 13 7 L 13 18 L 15 18 L 15 7 L 13 7 z" fill="#FF0000"></path>
                        </svg>
                    </span>
                </div>
            ),
            sortable: false
        }
    ];


    return (
        <Layout>
            <Toaster position='top-right' className='toaster' />
            <div className="px-4">
                <div className="admin-page mt-3 d-sm-flex justify-content-between align-items-center">
                    <div className="admin-heading" style={{ gap: "20px" }}>
                        <h4 className="mb-0">Insta Reels</h4>
                    </div>
                    <div className="add_btn">
                        <button onClick={onOpen}>Add Insta Reels</button>
                    </div>
                </div>

                <div className="datatable mt-3">
                    <DataTable
                        columns={columns}
                        data={instaFeedData || []}
                        progressPending={loading}
                        progressComponent={<p>Loading...</p>}
                        pagination
                        highlightOnHover
                    />
                </div>

                <div id="entryformContainer" className={`adminform entryform ${isFormopen ? 'open' : ''}`}>
                    <div className="closebtn">
                        <button className="" onClick={() => setIsFormopen(false)} >
                            <svg clipRule="evenodd" fillRule="evenodd" height="30" imageRendering="optimizeQuality" shapeRendering="geometricPrecision" textRendering="geometricPrecision" viewBox="0 0 6.82666 6.82666" width="30" xmlns="http://www.w3.org/2000/svg" version="1.1" xmlnsXlink="http://www.w3.org/1999/xlink" >
                                <g transform="matrix(1,0,0,1,0,0)">
                                    <g id="Layer_x0020_1">
                                        <rect fill="#ffffff00" height="6.827" rx="1.507" width="6.827" stroke="none" />
                                        <path d="m2.21002 1.41333-.79669.79669 1.20331 1.20331-1.20331 1.20331.79669.79669 1.20331-1.20331 1.20332 1.20331.79668-.79669-1.2033-1.20331 1.2033-1.20331-.79669-.79669-1.20331 1.2033z" fill="#fffffe" stroke="none" />
                                    </g>
                                </g>
                            </svg>
                        </button>
                    </div>
                    <div className="enForm">
                        <div className="text-center form-heading">
                            <h4>Add Insta Reels</h4>
                        </div>
                        <form onSubmit={onSave}>
                            {/* <div className="form-group">
                                <label htmlFor="formFile">Title</label>
                                <input type="text" className="form-control" id="title" name="title" value={formData.title} onChange={handleChange} />
                            </div> */}

                            {/* <div className="form-group">
                                <label htmlFor="formFile">Insta Url </label>
                                <input type="text" className="form-control" id="instaUrl" name="instaUrl" value={formData.instaUrl} onChange={handleChange} />
                            </div> */}

                            <div className="form-group">
                                <label htmlFor="formFile">File</label>
                                <input
                                    type="file"
                                    className="form-control"
                                    id="file"
                                    name="file"
                                    accept="image/png, image/jpeg, video/mp4, video/webm, video/ogg"
                                    onChange={handleChange}
                                    ref={fileInputRef}
                                />
                            </div>

                            <div className="form-group d-flex">
                                <div className="form-check">
                                    <input type="checkbox" className="form-check-input" id="isActive" name="isActive" checked={formData.isActive} onChange={handleChange} />
                                </div>
                                <label htmlFor="exampleFormControlInput1">isActive</label>
                            </div>

                            <div className="d-flex form-buttons" style={{ gap: "15px" }}>
                                <div className="submit-btn pt-2">
                                    <button type="submit">{instaFeedId ? 'Update' : 'Submit'}</button>
                                </div>
                                <div className="reset-btn pt-2">
                                    <button type='button' className="">Reset</button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </Layout>
    )
}

export default InstaFeed;